import React, { useState, useRef } from 'react'
import { TextField, TextFieldProps, IconButton, InputAdornment } from '@mui/material'
import { Visibility, VisibilityOff } from '@mui/icons-material'

export type PasswordFieldProps = Omit<TextFieldProps, 'type'>

export const PasswordField: React.FC<PasswordFieldProps> = ({ InputProps, inputRef, sx, ...props }) => {
  const [showPassword, setShowPassword] = useState(false)
  const localRef = useRef<HTMLInputElement | null>(null)

  const handleToggle = () => {
    const input = localRef.current
    const pos = input?.selectionStart
    setShowPassword((prev) => !prev)

    if (input && pos != null) {
      requestAnimationFrame(() => input.setSelectionRange(pos, pos))
    }
  }

  return (
    <TextField
      {...props}
      type={showPassword ? 'text' : 'password'}
      sx={sx}
      inputRef={(node: HTMLInputElement | null) => {
        localRef.current = node
        if (typeof inputRef === 'function') inputRef(node)
        else if (inputRef) (inputRef as React.MutableRefObject<HTMLInputElement | null>).current = node
      }}
      InputProps={{
        ...InputProps,
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={handleToggle}
              onMouseDown={(e) => e.preventDefault()}
              edge="end"
              size="small"
              sx={{ color: 'action.active' }}
            >
              {showPassword ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  )
}

export default PasswordField
